import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'CEMENTERIES_VIEW', {
  TITLE: 'Cementeries',
  NAME: 'Name',
  ACTIONS: 'Actions',
  SHOW: 'Show',
  EDIT: 'Edit',
  DELETE: 'Delete',
  DELETE_DIALOG_TITLE: 'Delete cementery',
  DELETE_DIALOG_MESSAGE: 'Are you sure you want to delete the cementery {{ name }}?',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'CEMENTERIES_VIEW', {
  TITLE: 'Cementerios',
  NAME: 'Nombre',
  ACTIONS: 'Acciones',
  SHOW: 'Ver',
  EDIT: 'Editar',
  DELETE: 'Eliminar',
  DELETE_DIALOG_TITLE: 'Eliminar cementerio',
  DELETE_DIALOG_MESSAGE: 'Estás seguro de querer eliminar el cementerio {{ name }}?',
});
